import { render } from "./serviceCharge.vue?vue&type=template&id=4911ccd0&scoped=true"
import script from "./serviceCharge.vue?vue&type=script&lang=js"
export * from "./serviceCharge.vue?vue&type=script&lang=js"

import "./serviceCharge.vue?vue&type=style&index=0&id=4911ccd0&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4911ccd0"]])

export default __exports__